import { Box, Grid, Typography } from "@mui/material";
import BAGrid from "../config/components/BAGrid";
import { useEffect, useState } from "react";
import BADatepicker from "../config/components/BADatepicker";
import BAIconbutton from "../config/components/BAIconbutton";
import SouthIcon from "@mui/icons-material/South";
import NorthIcon from "@mui/icons-material/North";
import DeleteIcon from '@mui/icons-material/Delete';
import BAModal from "../config/components/BAModal";
import BAInput from "../config/components/BAInput";
import BAButton from "../config/components/BAButton";
import { Get, Post, Put } from "../config/apimethods/apimethods";
import BAScreenHeader from "../config/components/BAScreenHeader";
import BAShowError from "../config/components/BAShowerror";
import BALoader from "../config/components/BALoader";
import CircularProgress from '@mui/material/CircularProgress';
import { setDate } from "../config/core/helpermethod";
import BalanceSheetListMenu from "../config/components/BalanceSheetList";
import SubjectIcon from '@mui/icons-material/Subject';
import SideDrawer from "../config/components/BASideDrawer";
import VisibilityIcon from '@mui/icons-material/Visibility';


function BalanceSheet() {
  const [openModal, setOpenModal] = useState(false);
  const [message, setMessage] = useState()
  const [showMessage, setShowMessage] = useState(false)
  const [balance, setBalance] = useState(0)
  const [balanceLoader, setBalanceLoader] = useState(false)
  const [todayBalanceSheetModel, setTodayBalanceSheetModel] = useState({})
  const [loader, setLoader] = useState(false)
  const [particularLoading, setParticularLoading] = useState(false)
  const [openLoader, setOpenLoader] = useState(false)
  const [creditList, setCreditList] = useState([])
  const [debitList, setDebitList] = useState([])
  const [amountIn, setAmountIn] = useState(0)
  const [amountOut, setAmountOut] = useState(0)
  const [currentBalance, setCurrentBalance] = useState(0)
  const [openSheetModal, setOpenSheetModal] = useState(false)
  const [openSideBar, setOpenSideBar] = useState(false)
  const [allSheetLoader, setAllSheetLoader] = useState(false)
  const [allBalanceSheet, setAllBalanceSheet] = useState([])
  const [sheetDate, setSheetDate] = useState(new Date())
  const [openAskModal, setOpenAskModal] = useState(false)
  const [selectedBalanceSheet, setSelectedBalanceSheet] = useState({})
  const [openSelectBalanceSheet, setOpenSelectBalanceSheet] = useState(false)

  let searchCriterea = {
    pageNo: 1,
    limit: 20,
    searchBy: '',
    searchVal: ''
  }

  const [cols, setCols] = useState([
    {
      label: "Particular",
      key: "particular",
    },
    {
      label: "Amount",
      key: "amount",
    },
  ]);
  const [model, setModel] = useState({});

  const getBalance = () => {
    setBalanceLoader(true)
    Get('balancesheet/getbalance').then(res => {
      setBalanceLoader(false)
      if (res.status) {
        setBalance(res.data?.balance)
      } else {
        setMessage(res)
        setShowMessage(true)
      }
    }).catch(err => {
      setBalanceLoader(false)
      setShowMessage(true)
      setMessage(err.message)
    })
  }


  const saveParticals = () => {

    let arr = [...creditList, ...debitList, model]

    setParticularLoading(true)
    Post('balancesheet/addparticular', {
      balanceSheetId: todayBalanceSheetModel._id,
      particulars: arr
    }).then(res => {
      setParticularLoading(false)
      setOpenModal(false)
      setModel({})
      getCurrentBalanceSheet()
    }).catch(err => {
      setParticularLoading(false)
    })
  };


  const openBalanceSheet = () => {
    setOpenLoader(true)
    Post('balancesheet/open', {
      openingTime: new Date(),
      sheetDate: sheetDate
    }).then((res) => {
      setOpenLoader(false)
      if (res.status) {
        setTodayBalanceSheetModel({ ...res.data })
      }
    }).catch((err) => {
      setOpenLoader(false)
      setShowMessage(true)
      setMessage(typeof err == 'string' ? err : err.response?.data?.errors)
    })
  }

  const closeBalanceSheet = () => {
    let obj = {
      id: todayBalanceSheetModel._id,
      closingBalance: (todayBalanceSheetModel?.openingBalance + (amountIn || 0)) - (amountOut || 0),
      closingTime: new Date()
    }
    Put('balancesheet/close', { ...obj }).then(res => {
      if (res.status) {
        getCurrentBalanceSheet()
      } else {
        setMessage(res.errors)
        setShowMessage(true)
      }
    }).catch(err => {
      setShowMessage(true)
      setMessage(err)
    })
  }



  const getCurrentBalanceSheet = () => {
    setLoader(true)
    Get('balancesheet/getTodayBalanceSheet', null, {
      currentDate: new Date()
    }).then(res => {
      setLoader(false)
      if (res.status) {
        if (res.data) {
          setTodayBalanceSheetModel({ ...res.data })
          let particulars = res.data.particulars
          setCreditList([...particulars.filter(x => x.type == 'in')])
          setDebitList([...particulars.filter(x => x.type == 'out')])
          let amountIn = 0
          let amountOut = 0
          particulars.forEach(x => {
            if (x.type == "in") {
              amountIn += x.amount
            } else {
              amountOut += x.amount
            }
          })
          setAmountIn(amountIn)
          setAmountOut(amountOut)
          let currentBalance = (+(todayBalanceSheetModel?.openingBalance) + (amountIn || 0)) - (amountOut || 0)
          setCurrentBalance(currentBalance)
        } else {
          setShowMessage(true)
          setMessage("No Balance Sheet Created for Today.")
        }
      } else {
        setShowMessage(true)
        setMessage(res.errors)
      }
    }).catch(err => {
      setLoader(false)
      setShowMessage(true)
      // setMessage(err)
      console.log(err)
    })
  }


  const delParticular = (i, type) => {

    if (type == 'credit') {
      creditList.splice(i, 1)
    } else if (type == 'debit') {
      debitList.splice(i, 1)
    }

    let arr = [...creditList, ...debitList]

    setParticularLoading(true)
    Post('balancesheet/addparticular', {
      balanceSheetId: todayBalanceSheetModel._id,
      particulars: arr
    }).then(res => {
      setParticularLoading(false)
      setOpenModal(false)
      setModel({})
      getCurrentBalanceSheet()
    }).catch(err => {
      setParticularLoading(false)
    })


  }


  const getAllSheets = () => {
    setAllSheetLoader(true)
    Get('balancesheet', null, {
      limit: searchCriterea.limit, pageNo: searchCriterea.pageNo
    }).then(res => {
      setAllSheetLoader(false)
      if (res.status) {
        setAllBalanceSheet(res.data)
      } else {
        setMessage(res.errors)
        setShowMessage(true)
      }
    }).catch(err => {
      setAllSheetLoader(false)
    })
  }

  useEffect(() => {
    getBalance()
    getCurrentBalanceSheet()
    getAllSheets()
  }, []);

  return (
    <>
      <BAModal innerContent={<Box>
        <Box className="p-2">
          <Box className="row">

            <Box className="col-md-4 p-2">

              <Typography className="p-2 bgLight rounded ">Opening Time : {selectedBalanceSheet.openingTime ?? '--'}</Typography>
            </Box>
            <Box className="col-md-4 p-2">

              <Typography className="p-2 bgLight rounded">Closing Time : {selectedBalanceSheet.closingTime ?? '--'}</Typography>
            </Box>
          </Box>

          <Box className="w-100 overflow-auto"  >
            <BAGrid datasource={selectedBalanceSheet.particulars} gridCols={[...cols, { label: 'Type', key: 'type' }]} />
          </Box>
          <Box>
            <Box className="p-1">
              <table className="table table-bordered">
                <tr>
                  <th>Opening Balance</th>
                  <td>{selectedBalanceSheet.openingBalance}</td>
                </tr>
                <tr>
                  <th>In</th>
                  <td>{amountIn}</td>
                </tr>
                <tr>
                  <th>Out</th>
                  <td>{amountOut}</td>
                </tr>
                <tr>
                  <th>Closing Balance</th>
                  <td>{selectedBalanceSheet.closingBalance || '--'}</td>
                </tr>
              </table>
            </Box>

          </Box>
        </Box>
      </Box>} modalFooter={<Box></Box>} open={openSelectBalanceSheet} close={(e) => setOpenSelectBalanceSheet(e)} modalTitle={`Balance Sheet ${selectedBalanceSheet.sheetDate}`} />
      <BAModal
        width="40vw"
        modalTitle={`Amount ${model.type}`}
        innerContent={
          <Box>
            <Box className="p-2">
              <BAInput value={model.particular} onChange={(e) => setModel({ ...model, particular: e.target.value })} label="Particular" />
            </Box>
            <Box className="p-2">
              <BAInput type='number' value={model.amount} onChange={(e) => setModel({ ...model, amount: e.target.value })} label="Amount" />
            </Box>
          </Box>
        }
        modalFooter={
          <Box className="text-end">
            <BAButton loading={particularLoading} onClick={saveParticals} label="Save" />
          </Box>
        }
        open={openModal}
        close={(e) => setOpenModal(e)}
      />
      <BAModal modalFooter={<Box className="text-center">
        <BAButton onClick={() => {
          setOpenAskModal(false)
          openBalanceSheet()
        }} label='Open Balance Sheet' />
      </Box>} modalTitle="Select Date!" innerContent={<Box>
        <Typography>By Default Today Date is selected if you want to open balance sheet for today press <span className="fw-bold">Open Balance Sheet</span> Button</Typography>
        <Box className="p-3">
          <BADatepicker value={sheetDate} onChange={(e) => setSheetDate(e)} />
        </Box>
      </Box>} width="30vw" open={openAskModal} close={(e) => setOpenAskModal(e)} />
      <SideDrawer title="Balance Sheets" body={<Box className="w-100 overflow-auto">
        <BAGrid datasource={allBalanceSheet} gridCols={[
          {
            label: '',
            key: '',
            className: 'btnCell',
            displayField: (e) => <BAIconbutton onClick={() => {
              setSelectedBalanceSheet({ ...e })
              setOpenSelectBalanceSheet(true)
            }} icon={<VisibilityIcon />} />
          },
          {
            label: 'Date',
            key: 'sheetDate'
          },
          {
            label: 'Opening',
            key: 'openingBalance'
          },
          {
            label: 'Closing',
            key: 'closingBalance'
          },
        ]} loading={allSheetLoader} />
      </Box>} closePanel={(e) => setOpenSideBar(e)} openPanel={openSideBar} />
      <BAShowError message={message} open={showMessage} close={(e) => setShowMessage(e)} />
      <BAScreenHeader customTitle={<Box className="d-flex align-items-center">
        <Typography variant="h5" className="fw-bold">
          Balance Sheet {todayBalanceSheetModel?.sheetDate && `(${todayBalanceSheetModel.sheetDate})`}
        </Typography>

      </Box>} buttonsList={[
        {
          displayField: !todayBalanceSheetModel.isOpen && <BAButton loading={openLoader} onClick={() => {
            setOpenAskModal(true)
          }} label='Open' />
        },
        {
          displayField: todayBalanceSheetModel._id && todayBalanceSheetModel.isOpen && <BAButton onClick={closeBalanceSheet} label='Close' />
        },
        {
          displayField: <BAIconbutton onClick={() => setOpenSideBar(true)} icon={<SubjectIcon />} />
        }
      ]} />
      <Box>
        <Box className="p-2">
          <Box className="row">
            <Box className="col-md-4 p-2">
              <span className="bg-light cursor-pointer border w-100 d-inline-block text-center fs-5 rounded p-1 mb-2" onClick={getBalance} >Current Balance : {balanceLoader ? <CircularProgress size={20} /> : balance ?? "--"}</span>
            </Box>
            <Box className="col-md-4 p-2">

              <Typography className="p-2 bgLight rounded ">Opening Time : {todayBalanceSheetModel.openingTime ?? '--'}</Typography>
            </Box>
            <Box className="col-md-4 p-2">

              <Typography className="p-2 bgLight rounded">Closing Time : {todayBalanceSheetModel.closingTime ?? '--'}</Typography>
            </Box>
          </Box>
        </Box>

        <Grid container>
          <Grid item xs={12} sm={12} md={6}>
            <Box className="p-2">
              <Box className="d-flex border-bottom border-bottom-2 border-dark justify-content-between align-items-center">
                <Typography variant="h5" className="text-center pb-2">
                  Credit
                </Typography>
                {todayBalanceSheetModel.isOpen && <BAIconbutton
                  onClick={() => {
                    model.type = "in"
                    setOpenModal(true)
                  }}
                  icon={<SouthIcon />}
                />}
              </Box>
              <BAGrid datasource={creditList} gridCols={[{
                label: "Delete",
                key: "del",
                className: "btnCell",
                displayField: (e, i) => todayBalanceSheetModel.isOpen && <BAIconbutton color='error' onClick={() => delParticular(i, 'credit')} icon={<DeleteIcon />} />
              }, ...cols]} />

              <Box>
                <table className="table table-bordered">
                  <tr>
                    <th>Opening Balance</th>
                    <td>{todayBalanceSheetModel.openingBalance}</td>
                  </tr>
                  <tr>
                    <th>Cr</th>
                    <td>+{amountIn}</td>
                  </tr>
                  <tr>
                    <th>Total</th>
                    <td>{todayBalanceSheetModel.openingBalance + amountIn}</td>
                  </tr>
                  <tr>
                    <th></th>
                    <td>{((todayBalanceSheetModel.openingBalance + amountIn) - amountOut) - (todayBalanceSheetModel.openingBalance + amountIn)}</td>
                  </tr>
                  <tr>
                    <th>Balance</th>
                    <td>{(todayBalanceSheetModel.openingBalance + amountIn) - amountOut}</td>
                  </tr>

                </table>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Box className="p-2">
              <Box className="d-flex border-bottom border-bottom-2 border-dark justify-content-between align-items-center">
                <Typography variant="h5" className="text-center pb-2">
                  Debit
                </Typography>
                {todayBalanceSheetModel.isOpen && <BAIconbutton
                  onClick={() => {
                    model.type = 'out'
                    setOpenModal(true)
                  }}
                  icon={<NorthIcon />}
                />}
              </Box>
              <BAGrid datasource={debitList} gridCols={[{
                label: "Delete",
                key: "del",
                className: "btnCell",
                displayField: (e, i) => todayBalanceSheetModel.isOpen && <BAIconbutton color='error' onClick={() => delParticular(i, 'debit')} icon={<DeleteIcon />} />
              }, ...cols]} />
              <Box>
                <table className="table table-bordered">
                  <tr>
                    <th>Total Dr</th>
                    <td>-{amountOut}</td>
                  </tr>
                  <tr>
                    <th>Closing Balance</th>
                    <td>{(todayBalanceSheetModel.openingBalance + amountIn) - amountOut}</td>
                  </tr>

                </table>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
export default BalanceSheet;
